import { Button } from "@mui/material"
import styled from "styled-components"

const StyledActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
  }
`
const StyledButtons = styled.div`
  display: flex;
  grid-gap: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  button {
    width: 100%;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    margin-top: 0px;
    button {
      width: auto;
    }
  }
`

const StyledTermsAction = styled.button`
  background-color: transparent;
  border: none;
  font-family: OENaPro;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  color: ${(p) => p.theme.colors.black};
  padding: 0px;
  height: 19px;
  border-bottom: 2px solid ${(p) => p.theme.colors.black};
  align-self: center;
  cursor: pointer;
`

type Props = {
  onTermsOpen: () => void
  onCopyOpen: () => void
  onContactOpen: () => void
}

function BottomActions({ onTermsOpen, onCopyOpen, onContactOpen }: Props) {
  return (
    <StyledActionsContainer>
      <StyledTermsAction onClick={onTermsOpen}>לתנאים ותקנון</StyledTermsAction>
      <StyledButtons>
        <Button
          variant="outlined"
          onClick={onCopyOpen}
          disableFocusRipple={false}
          disableRipple={false}
        >
          לשתף את ההצעה
        </Button>
        <Button
          onClick={onContactOpen}
          disableFocusRipple={false}
          disableRipple={false}
        >
          חזרו אליי לגבי ההצעה
        </Button>
      </StyledButtons>
    </StyledActionsContainer>
  )
}

export default BottomActions
